<template>
  <app-icon
    :color="color"
    :name="icon"
    :size="size"
    variant="solid"
  />
</template>

<script setup>
import { computed } from 'vue';
import { PayableStatus } from '@/constants/payableStatus';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator(value) {
      return Object.values(PayableStatus).includes(value);
    },
  },
  size: {
    type: String,
    default: 'xs',
    validator(value) {
      return ['xs', 'sm', 'md', 'lg'].includes(value);
    },
  },
  payableIcon: {
    type: String,
    default: 'check',
  },
  notPayableIcon: {
    type: String,
    default: 'alert-circle',
  },
  partiallyPayableIcon: {
    type: String,
    default: 'alert-circle',
  },
});

const color = computed(() => {
  const colorMap = {
    [PayableStatus.PAYABLE]: 'success',
    [PayableStatus.PARTIALLY_PAYABLE]: 'warning',
    [PayableStatus.NOT_PAYABLE]: 'error',
  };
  return colorMap[props.status];
});

const icon = computed(() => {
  const iconMap = {
    [PayableStatus.PAYABLE]: props.payableIcon,
    [PayableStatus.PARTIALLY_PAYABLE]: props.partiallyPayableIcon,
    [PayableStatus.NOT_PAYABLE]: props.notPayableIcon,
  };
  return iconMap[props.status];
});
</script>
